import React from "react";
import { withSentryTracing } from "supercell-frontend-base/src/tracing/sentry";
import { AppController } from "./controller";

import { SnowplowContextProvider } from "supercell-frontend-base/src/analytics/snowplow";
import {
    RogueGameParams,
    RogueGameParamsSchema,
} from "../../validation/game-params";
import {
    GameParamsContextProvider,
    DEFAULT_STATE,
} from "supercell-frontend-base/src/stores/gameParams";

const WithGameParams = (props) => {
    return (
        <SnowplowContextProvider
            config={{
                appId: window.SNOWPLOW_APP_ID,
                collectorUrl: window.SNOWPLOW_COLLECTOR_URL,
            }}
        >
            <GameParamsContextProvider<RogueGameParams>
                initialState={DEFAULT_STATE}
                gameParamsParser={RogueGameParamsSchema}
            >
                <AppController {...props} />
            </GameParamsContextProvider>
        </SnowplowContextProvider>
    );
};

export const App = withSentryTracing(WithGameParams);
